// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Buefy from 'buefy'
import Vuemoment from 'vue-moment'
import store from './store'
import axios from './axios'
import pluralize from 'pluralize'
import wysiwyg from 'vue-wysiwyg'

Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    table: true
  }
}) // config is optional. more below
require('./assets/sass/main.scss')
Vue.config.productionTip = false

/* Moment js locale stuff */
const moment = require('moment')
require('moment/locale/sv')
Vue.use(Vuemoment, { moment })

Vue.use(Buefy, {
  defaultIconPack: 'fa'
})

Vue.prototype.$http = axios
Vue.prototype.$pluralize = pluralize
store.dispatch('init')
  .then((response) => {
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  })
  .catch((error) => {
    console.log(error)
    /* eslint-disable no-new */
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App)
    })
  })
